// extracted by mini-css-extract-plugin
module.exports = {"AnswersList":"AnswersList__AnswersList--3ssxG"};